// extracted by mini-css-extract-plugin
export default {"watchScreen_player":"WatchScreen_watchScreen_player__6ovXH","VideoHorizontal":"WatchScreen_VideoHorizontal__wdXbU"};